import React from 'react';

import {
  ButtonSkeleton,
  HeadlineSkeleton,
  InputSkeleton,
  ImageSkeleton,
  TextSkeleton,
} from '@xingternal/malt-skeleton';
import { testable } from '@xingternal/malt-util';
import { QA_MALT } from '@xingternal/malt-constants';

import Spacer from './../../Components/Spacer/Spacer';

import styles from './LoadingSkeleton.css';

const TestableDiv = testable(QA_MALT, 'div');

const FormLoadingSkeleton = () => (
  <TestableDiv testId={'login-loading-skeleton'}>
    <ImageSkeleton className={styles.image} width={96} height={96} />
    <HeadlineSkeleton size={'large'} />
    <InputSkeleton />
    <Spacer size={4} />
    <InputSkeleton />
    <TextSkeleton lineCount={1} />
    <Spacer size={2} />
    <div className={styles.buttonContainer}>
      <ButtonSkeleton className={styles.button} />
    </div>
  </TestableDiv>
);

export default FormLoadingSkeleton;
